import { Form, FormProps, Input, Select } from 'antd';
import React, { useMemo } from 'react';

import { EPanelOpenMethod } from '@components/block-event-single/store';
import { categoryTypeOptions } from '@src/emp-3.0/components/custom-dimension/custom-dimension-panel/constant';
import { validateDimensionName } from '@src/emp-3.0/domain/dimension';

import { FormLabel } from './styled';

const CustomDimensionInfoForm: React.FC<FormProps & { mode?: EPanelOpenMethod }> = ({
  mode,
  ...FormProps
}) => {
  const isViewMode = useMemo(() => mode === EPanelOpenMethod.VIEW, [mode]);

  return (
    <Form
      labelCol={{
        flex: '130px',
      }}
      labelAlign="left"
      colon={false}
      {...FormProps}
    >
      <Form.Item
        name="display_name"
        label={<FormLabel>Dimension Name :</FormLabel>}
        required={false}
        rules={[
          { required: true, message: 'required!' },
          () => ({
            validator(_, value) {
              const { failed, message } = validateDimensionName(value);
              if (value && failed) {
                return Promise.reject(new Error(message));
              }
              return Promise.resolve();
            },
          }),
        ]}
      >
        <Input style={{ width: '100%' }} placeholder="Please input..." bordered={!isViewMode} />
      </Form.Item>
      <Form.Item
        name="category"
        label={<FormLabel>Dimension Category :</FormLabel>}
        dependencies={['event_name']}
        required={false}
      >
        <Select
          disabled
          bordered={!isViewMode}
          showArrow={!isViewMode}
          options={categoryTypeOptions}
          placeholder="Please Select..."
        />
      </Form.Item>
    </Form>
  );
};

export default CustomDimensionInfoForm;
